import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const EmotionalSection = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="emotional-section"
      className="relative bg-[#F9F8F6] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <Reveal className="lg:col-span-5">
            <p className="overline mb-6">— {t.emotional.overline}</p>
            <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A1A1A]">
              {t.emotional.title}{" "}
              <span className="italic text-[#D4AF37]">
                {t.emotional.title_accent}
              </span>
            </h2>
            <p className="mt-8 text-[#666666] text-base md:text-lg leading-relaxed max-w-md">
              {t.emotional.sub}
            </p>
            <div className="gold-line mt-10" />
          </Reveal>

          <div className="lg:col-span-7">
            <ul className="divide-y divide-[#E5E5E5] border-y border-[#E5E5E5]">
              {t.emotional.items.map((item, i) => (
                <motion.li
                  key={i}
                  data-testid={`emotional-item-${i}`}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{
                    duration: 0.85,
                    delay: i * 0.07,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                  className="py-6 md:py-7 flex items-baseline gap-6 group"
                >
                  <span className="font-display text-xs md:text-sm text-[#D4AF37] w-8 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="flex-1">
                    <h3 className="font-display text-xl md:text-2xl text-[#1A1A1A] font-normal tracking-tight">
                      {item.k}
                    </h3>
                    <p className="text-[#666666] mt-1 text-sm md:text-base">
                      {item.v}
                    </p>
                  </div>
                  <motion.span
                    initial={{ width: 20 }}
                    whileHover={{ width: 56 }}
                    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                    className="hidden md:block h-px bg-[#1A1A1A]/20 group-hover:bg-[#D4AF37] transition-colors"
                  />
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
